import { gql } from '@apollo/client'

export const GET_BIDS_BY_BOOKING_QUERY = gql`
  query GetDriverBids($where: DriverBidFilterInput!) {
    driverBids(where: $where) {
      id
      price
      currency {
        id
        name
        symbol
      }
      eta
      notes
      driverId
      driver {
        id
        name
        averageRating
        isActive
      }
      bookingId
      vehicleId
      vehicle {
        id
        vehicleType {
          id
          name
        }
      }
      createdAt
      isAllocated
    }
  }
`

export const GET_DRIVER_BID_QUERY = gql`
  query GetDriverBid($driverBidId: Long!) {
    driverBid(driverBidId: $driverBidId) {
      id
      price
      currencyId
      eta
      notes
      driverId

      bookingId
      vehicleId
      isEnabled
      bookingId
      vehicle {
        id
        vehicleType {
          id
          name
        }
      }
    }
  }
`

export const GET_BOOKING_BIDS_QUERY_PAGED = gql`
  query GetBookingBidsPaged(
    $bookingId: Long!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [DriverBidSortInput!]
    $where: DriverBidFilterInput
  ) {
    bookingBidsPaged(
      bookingId: $bookingId
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          price
          currency {
            id
            name
            symbol
          }
          eta
          notes
          driverId
          driver {
            id
            name
            averageRating
            telephoneNumber
            alternativeTelephoneNumber
            primaryDriver {
              id
              name
            }
            isActive
            primaryDriverName
          }
          bookingId
          vehicleId
          vehicle {
            id
            vehicleType {
              id
              name
            }
          }
          createdAt
          isAllocated
          isActive
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_SUPPLIERS_BIDS_BY_BOOKING_QUERY_PAGED = gql`
  query GetSuppliersBidsPaged(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [DriverBidSortInput!]
    $where: DriverBidFilterInput
  ) {
    suppliersBidsPaged(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          price

          eta
          notes
          driverId
          driver {
            id
            name
            telephoneNumber
            alternativeTelephoneNumber
          }
          bookingId
          vehicleId
          vehicle {
            id
            vehicleType {
              id
              name
            }
          }

          currency {
            id
            name
            symbol
          }
          createdAt
          isAllocated
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_DRIVER_BID_FOR_BOOKING_QUERY = gql`
  query getDriverBidForBooking($id: Long!, $where: DriverBidFilterInput) {
    driverBidForCurrentDriver(bookingId: $id, where: $where) {
      id
      price
      isAllocated
      eta
      notes
      bookingId
      vehicleId
      currencyId
      currency {
        id
        symbol
      }
      driverId
      isActive
    }
  }
`

export const GET_SUBDRIVER_BID_FOR_BOOKING_QUERY = gql`
  query getSubdriverBidForBooking($id: Long!) {
    driverBidForSubdriver(bookingId: $id) {
      id
      price
      isAllocated
      eta
      notes
      bookingId
      vehicleId
      currencyId
      currency {
        id
        symbol
      }
      driverId
    }
  }
`
